/* 因官网有纯静态页面。并非全部都会用到axios，所以未挂载全局，需要时在中页面引入使用。
 * 使用axios时要同时引入api接口列表在utils/api
 **/

import axios from "axios";
import qs from "qs";


axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

//post请求头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// 表示跨域请求时是否需要使用凭证 允许跨域携带cookie信息
axios.defaults.withCredentials = false;

// 允许跨域
axios.defaults.headers.post["Access-Control-Allow-Origin-Type"] = "*";

//设置超时
axios.defaults.timeout = 30000;

axios.interceptors.request.use(
  config => {
    config.headers['mp-token'] = 'token' || '';
    config.headers['mp-app'] = 'APPCODE';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.status == 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {

    // alert(JSON.stringify(error), '请求异常', {
    //   confirmButtonText: '确定',
    //   callback: (action) => {
    //     console.log(action)
    //   }
    // });
    console.log('response-err:' + error);
    return Promise.reject(error)
  }
);
export function Post(uri, data) {
  return new Promise((resolve, reject) => {
    axios.post(uri, qs.stringify(data)).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    });
  })
}

export function Get(url, data) {
  return new Promise((resolve, reject) => {
    axios.get(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}